import { Injectable } from "@angular/core";
import { FormatConfigService } from "./core/services/format-config.service";
import { environment } from "../environments/environment";
import { OAuthService } from "angular-oauth2-oidc";
import { Location } from "@angular/common";
import { keysToTranslate } from '../i18n/keys-to-translate';


@Injectable()
export class AppConfig {

  constructor(private formatConfigService: FormatConfigService,
              private location: Location,
              private oauth: OAuthService) {
    keysToTranslate([
      'CodeGläubiger',
      'CodeSchuldner',
      'RolleGläubiger',
      'Komponenten',
      'MaximalResultWarning'
    ])
  }

  public load() {
    let redirectUri;
    if (environment.postLogoutRedirectUri === null || environment.postLogoutRedirectUri === undefined) {
      redirectUri = window.location.origin + this.location.prepareExternalUrl("/logout");
    } else {
      redirectUri = environment.postLogoutRedirectUri;
    }
    this.oauth.configure({
      issuer: environment.openIdConnect.issuer,
      responseType: 'code',
      scope: 'profile email roles',
      requireHttps: !environment.openIdConnect.noSSL,
      clientId: environment.openIdConnect.clientId,
      showDebugInformation: !environment.production,
      strictDiscoveryDocumentValidation: false,
      postLogoutRedirectUri: redirectUri,
    });
    return this.formatConfigService.init();
  }

}
